export default {"src":"/_next/static/image/public/img/icons/close_black_round.d21c84ba66083408fbf9b32fec04aa8c.svg","height":46,"width":46};